import { Typography, Button, Avatar, List, ListItem, Chip } from "@mui/material";
import { Box } from "@mui/system";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Customer, CustomerStatus } from "../models";
import theme from "src/theme";
import RoleChip from "@arelia-components/ui-atoms/RoleChip";
import { useNavigate } from "react-router-dom";
import { MouseEvent } from "react";

type Props = {
  customers: Customer[] | undefined,
  activeCustomer: Customer | null,
  setActiveCustomer: (customer: any) => void
};

const statusColorMap = {
  [CustomerStatus.Inactive]: "secondary",
  [CustomerStatus.Registered]: "warning",
  [CustomerStatus.Closed]: "error"
}

export default function CustomersList({ customers, setActiveCustomer, activeCustomer }: Props) {
  const navigate = useNavigate();

  const goToDetails = (customerId: string) => {
    navigate("/hq/customers/" + customerId);
  };

  const showQuickView = (e: MouseEvent<HTMLButtonElement>, customer: Customer) => {
    e.stopPropagation();
    setActiveCustomer(customer);
  }

  return <List>
    {customers && customers.map(customer =>
      <ListItem divider key={customer.identityId}>
        <Box
          sx={styles.containerBox(activeCustomer?.identityId === customer.identityId)}
          onClick={() => goToDetails(customer.identityId)}
        >
          <Box sx={styles.sectionBox}>
            <Avatar sx={styles.avatar} src={customer.avatarUrl}></Avatar>
            <Box sx={styles.nameContainer}>
              <Typography variant="subtitle2">
                {customer.band?.name && customer.fullName
                  ? `${customer.band.name} / ${customer.fullName}`
                  : customer.band?.name || customer.fullName || customer.displayName}
              </Typography>
              <Typography variant="caption" sx={styles.email}>{customer.email}</Typography>
            </Box>
            {customer.band?.location && <Typography sx={styles.location}>({customer.band?.location})</Typography>}
            <RoleChip role={customer.role} />
          </Box>
          <Box sx={styles.sectionBox}>
            {customer.status !== CustomerStatus.Active && <Chip label={customer.status} color={statusColorMap[customer.status] as any} size="small" />}
            <Button variant="text" sx={styles.detailsButtong} onClick={(e) => showQuickView(e, customer)}>
              View Profile <ArrowForwardIcon sx={styles.detailsIcon}></ArrowForwardIcon>
            </Button>
          </Box>
        </Box>
      </ListItem>
    )}
  </List>
}

const styles = {
  containerBox(isActive: boolean) {
    return {
      display: "flex",
      justifyContent: "space-between",
      padding: "6px",
      borderRadius: "6px",
      backgroundColor: isActive ? "rgba(6, 178, 218, 0.1)" : "transparent",
      width: "100%",
      '&:hover': {
        backgroundColor: "rgba(6, 178, 218, 0.1)",
        cursor: "pointer"
      }
    };
  },
  sectionBox: {
    display: "flex",
    gap: "15px",
    alignItems: "center"
  },
  avatar: {
    width: "30px",
    height: "30px",
    borderRadius: "30px"
  },
  location: {
    color: theme.palette.grey[400]
  },
  detailsButtong: {
    fontWeight: 500,
    fontSize: "10px",
    padding: "6px 12px"
  },
  detailsIcon: {
    marginLeft: "10px",
    fontSize: "18px"
  },
  nameContainer: {
    display: "flex",
    flexDirection: "column",
  },
  email: {
    color: theme.palette.primary.main,
    fontSize: "0.75rem",
    lineHeight: 1.2
  }
}
